import { Component, OnInit, Input } from '@angular/core';
import { DAO } from '../../../modal/DAO';
import { ServiceLayer } from '../../../services/serviceLayer';
import * as _ from 'lodash';

@Component({
  selector: 'app-client-data',
  templateUrl: './client-data.component.html',
  styleUrls: ['./client-data.component.css']
})
export class ClientDataComponent implements OnInit {

  @Input() clientData: any;
  public tempclientData:any
  public isEditControls: any = {};
  constructor(public dao: DAO, public serviceLayer: ServiceLayer,) {}

  ngOnInit(): void {
    
  }
  //==============show the control when click the edit icon===========
  editTheDetails(controlName) {
    //========get the initial client data for backup use========
    if(this.clientData && this.tempclientData ===undefined){
      this.tempclientData= _.cloneDeep(this.clientData);
    }
    this.isEditControls[controlName] = true;
    if(controlName=="PolicyPeriod"){
      this.clientData.policyStartDate=new Date(this.clientData.policyStartDate); 
      this.clientData.policyEndDate=new Date(this.clientData.policyEndDate); 
    }
    if(controlName=="HasBlanketInsured"){
      if(!this.clientData.isBlanketInsured){
        this.clientData.isBlanketInsured=false;
        this.clientData.isBlanketInsured="No";
      }
      else{
        this.clientData.isBlanketInsured=true;
        this.clientData.isBlanketInsured="Yes"
      }
    }
  }
  //=============Show lable from control view===============
  skipEdit(controlName) {
    this.isEditControls[controlName] = false;
    if(controlName=="HasBlanketInsured"){
      if(this.clientData.isBlanketInsured=="No"){
        this.clientData.isBlanketInsured=false
      }
      else{
        this.clientData.isBlanketInsured=true;
      }
    }
  }
  //=============Show lable from all control view===============
  skipAllEdit(){
    this.isEditControls= [];
    this.clientData= _.cloneDeep(this.tempclientData);

  }
  //=========input control focused issue inside the array======
  returnIndex(index) {
    return index;
  }
}
